import React from 'react'
import PropTypes from 'prop-types'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import styles from './Health.module.scss'
import { Button } from '../../features/section-components/Button'

function HealthMobile({
  t, status, healthCheck, error, refresh, handleRefresh, ServerStatusIndicator, content
}) {
  return (
    <MarginWrapper>
      <div className={styles.mobileLeftAlignStyle}>
        <header style={{ fontSize: '1.5rem', fontWeight: 'bold', paddingBottom: '20px' }}>{t('healthHeader')}</header>
        <header>{t('health-api-header')}</header>
        <hr className={styles.topLine} />
        <ServerStatusIndicator status={status} healthCheck={healthCheck} t={t} />
        {content}
        {status === 'failed' && <p>Error: {error}</p>}
        <div style={{ textAlign: 'left', paddingTop: '10px' }}>
          <Button onClick={handleRefresh} disabled={refresh} text={t('health-refresh-api-button')} buttonStyle="cta-grey-oval" />
        </div>
      </div>
    </MarginWrapper>
  )
}

HealthMobile.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  healthCheck: PropTypes.shape({
    idp: PropTypes.bool,
    status: PropTypes.bool,
    uptime: PropTypes.string,
    error: PropTypes.string
  }).isRequired,
  error: PropTypes.string,
  refresh: PropTypes.bool.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  ServerStatusIndicator: PropTypes.func.isRequired,
  content: PropTypes.node.isRequired,
}

HealthMobile.defaultProps = {
  error: null
}
export default HealthMobile
